import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { OfferingCardLane } from '@ole-ui/ole-ui-components';
import useMobxStores from 'hooks/useMobxStores';
import { Link } from 'react-mobx-router5';
import { BaseOfferingCard } from 'components/OfferingCards';
import { CommonLaneProps } from './types';

const SavedForLaterLane = ({ expanded, onTitleClick }: CommonLaneProps) => {
  const { t } = useTranslation();
  const { catalogStore } = useMobxStores();

  return (
    <OfferingCardLane
      className="new_lane"
      emptyMessage={
        <p className="empty-message">
          {t('You have nothing saved for later.')}{' '}
          <Link href routeName="catalog">
            {t('Browse the catalog to search offerings')}
          </Link>
        </p>
      }
      expanded={expanded}
      items={catalogStore.savedForLaterCatalogEntries}
      onTitleClick={onTitleClick}
      renderItem={(entry) => <BaseOfferingCard entry={entry} />}
      title={t('Saved for later')}
    />
  );
};

export default observer(SavedForLaterLane);
